export default __webpack_public_path__ + "static/Teacher-with-student-0c7f4d3643c5fd866e6a6f089656efd3.svg";